import { find } from 'lodash/fp';
import { createSelector } from 'reselect';

import { IRootState } from '../reducers';
import { ChatState } from '../reducers/chat';

const chatSelector = (state: IRootState): ChatState => state.chat;

export const getChatUser = createSelector(
  chatSelector,
  (chat: ChatState) => chat?.chatUser || null,
);
export const getChatNotification = createSelector(
  chatSelector,
  (chat: ChatState) => chat?.chatNotifications || null,
);
export const getCountUpdateLoader = createSelector(
  chatSelector,
  (chat: ChatState) => chat?.loaders.countUpdate,
);

export const getChatUserLoading = createSelector(
  chatSelector,
  (chat: ChatState) => chat?.loaders.chatUserLoading,
);

export const getCurrentConversationId = createSelector(
  chatSelector,
  (chat: ChatState) => chat?.conversation?.id || null,
);

export const getSelectedChatUser = (state: IRootState, talkId: string) =>
  createSelector([getChatUser], (chatUsers) =>
    find({ chatId: talkId }, chatUsers),
  )(state);

export const getSearchUserLoading = createSelector(
  chatSelector,
  (chat: ChatState) => chat?.loaders.searchLoading,
);

export const getChat = createSelector(
  chatSelector,
  (chat: ChatState) => chat.conversation || null,
);

export const sendMessageLoading = createSelector(
  chatSelector,
  (chat: ChatState) => chat.loaders.sendMessageLoading,
);

export const createChatGroupLoading = createSelector(
  chatSelector,
  (chat: ChatState) => chat.loaders.createGroupLoading,
);

export const updateChatGroupLoading = createSelector(
  chatSelector,
  (chat: ChatState) => chat.loaders.updateGroupLoading,
);

export const fileUrl = createSelector(
  chatSelector,
  (chat: ChatState) => chat.fileUrl,
);

export const presignedUrlLoader = createSelector(
  chatSelector,
  (chat: ChatState) => chat.loaders.getPresignedUrlLoader,
);

export const fileUploadDetails = createSelector(
  chatSelector,
  (chat: ChatState) => ({
    uploadedCount: chat.fileUrl.uploadedCount,
    totalFiles: chat.fileUrl.totalFiles,
    remainingFiles: chat.fileUrl.remainingFiles,
    success: chat.fileUrl.success,
  }),
);

export const deleteChatGroupLoading = createSelector(
  chatSelector,
  (chat: ChatState) => chat.loaders.deleteGroupLoading,
);

export const getIsOldChat = createSelector(
  chatSelector,
  (chat: ChatState) => chat.isOldChat,
);

export const getConversationLoading = createSelector(
  chatSelector,
  (chat: ChatState) => chat.loaders.conversationLoading,
);
export const getUpdateConversationLoading = createSelector(
  chatSelector,
  (chat: ChatState) => chat.loaders.updateConversationLoading,
);
export const getPeerUsers = createSelector(
  chatSelector,
  (chat: ChatState) => chat?.conversation?.peerUsers || [],
);
